import moment from "moment"
import Head from 'next/head'

import { useCountry } from "lib/country"
import { useLanguages } from "lib/languages"

export const StructuredData = ({ film, duration }) => {
	const { country, countrySlug } = useCountry()
	const { current } = useLanguages()

	if (film.id === 9999999) {
		return null
	}

	return (
		<Head>
			<script type="application/ld+json" dangerouslySetInnerHTML={{
					__html: `{
					"duration":"${ formatDuration(duration) }",
					"actor":[${ formatActorList(film.actors) }],
					"@type":"Movie",
					"name":"${ film.name }",
					"image":"${ formatImage(film) }",
					"url":"https://www.lacinetek.com/${ countrySlug }/film/${ film.linkRewrite }",
					"description":"${ formatDescription(film) }",
					"releasedEvent":{"@type":"PublicationEvent","startDate":"${ formatStarDate(film) }","location":{"@type":"Country","name": "${ formatFilmOrigin(film) }"}},
					"dateCreated":"${ formatDateCreated(film) }",
					"director":{"@type":"Person","name":"${ formatFilmDirector(film) }"},
					"@context":["http://schema.org", {"@language": "${ country.isoCode }-${ current }"}],
					"potentialAction":${ formatPotentialAction(film) }
				}`
			}} />
		</Head>
	)
}

const formatDescription = (film) => {
	if (!film.description) {
		return ''
	}

	return film.description.replace( /(<([^>]+)>)/ig, '').replace( /(?:\r\n|\r|\n)/g, '').replace(/"/g, '&quo;')
}

const formatActorList = (actors) => {
	return actors.map(actor => {
		return (
			`{ "@type":"Person","name": "${ actor.name }" }`
		)
	})
}

const formatDuration = (duration) => {
	return moment.duration(duration, 'minutes').toISOString()
}

const formatFilmDirector = (film) => {
	return film.director ? film.director : ''
}

const formatDateCreated = (film) => {
	return film.year ? film.year : ''
}

const formatFilmOrigin = (film) => {
	return film.origin ? film.origin : ''
}

const formatStarDate = (film) => {
	return film.year ? film.year : ''
}

const formatImage = (film) => {
	if (!film.images) {
		return ''
	}

	let imageUrl = film.images[0].source

	film.images.forEach(image => {
		if (image.type === 'cover_large') {
			imageUrl = image.source
		}
	});

	return imageUrl
}

const formatPotentialAction = (film) => {
	if (!film.available) {
		return '{}'
	}

	const { countrySlug } = useCountry()

	return `{
		"@type": "WatchAction",
		"target": [
			{
			"@type": "EntryPoint",
			"urlTemplate": "https://www.lacinetek.com/${ countrySlug }/film/${ film.linkRewrite }?autoplay=true&utm_medium=fluxmovie&utm_source=google",
			"actionPlatform": [
				"http://schema.org/DesktopWebPlatform",
				"http://schema.org/MobileWebPlatform",
				"http://schema.org/IOSPlatform",
				"http://schema.org/AndroidPlatform",
				"http://schema.googleapis.com/GoogleVideoCast",
				"http://schema.org/AndroidTVPlatform"
				]
			}
		],
		"actionAccessibilityRequirement": {
			"@type": "ActionAccessSpecification",
			"category": "purchase",
			"eligibleRegion": {
				"@type": "Country",
				"name": "FR"
			},
			"expectsAcceptanceOf": {
				"@type": "Offer",
				"itemOffered": {
					"@type": "AggregateOffer",
					"lowPrice": "${ Math.min(...film.accessModes.map(access => access.price)) } €"
				}
			}
		}
	}`
}
